import { Highlightable } from '@angular/cdk/a11y';
import { Component, ElementRef, HostBinding, HostListener, Inject, Input } from '@angular/core';
import { SelectSearchParent, SELECT_SEARCH_PARENT } from '../select-search.token';

let nextId = 0;

const INLINE_ELEMENTS = /^(A|ABBR|B|BDI|BDO|CITE|CODE|DFN|EM|FONT|I|KBD|MARK|Q|S|SAMP|SMALL|SPAN|STRONG|SUB|SUP|TIME|U|VAR)$/;

/**
 * The element's innerText, the same whether or not it is rendered. A closed or filtered-out item
 * isn't, and innerText then falls back to textContent, which runs <div>a</div><div>b</div> together as "ab".
 */
function readText(node: Node): string {
    return Array.from(node.childNodes).map(child => {
        if (child.nodeName === '#text') {
            return child.nodeValue;
        }
        if (child.nodeName === '#comment') {
            return '';
        }
        return INLINE_ELEMENTS.test(child.nodeName) ? readText(child) : ` ${readText(child)} `;
    }).join('');
}

@Component({
    selector: 'app-select-item',
    template: '<ng-content></ng-content>',
    styleUrls: ['./select-item.component.scss'],
})
export class SelectItemComponent implements Highlightable {
    @Input()
    value: any;

    @HostBinding('attr.id')
    id = `select-item-${nextId++}`;

    @HostBinding('attr.role')
    role = 'option';

    @HostBinding('class.select-item--active')
    active = false;

    @HostBinding('class.select-item--hidden')
    hidden = false;

    @HostBinding('class.select-item--selected')
    @HostBinding('attr.aria-selected')
    get selected() {
        return this._select.isSelected(this.value);
    }

    get text() {
        return readText(this._elementRef.nativeElement).replace(/\s+/g, ' ').trim();
    }

    constructor(
        @Inject(SELECT_SEARCH_PARENT) private _select: SelectSearchParent,
        private _elementRef: ElementRef<HTMLElement>
    ) {}

    @HostListener('click')
    onClick() {
        this._select.selectValue(this.value);
    }

    setActiveStyles() {
        this.active = true;
    }

    setInactiveStyles() {
        this.active = false;
    }

    scrollIntoView() {
        this._elementRef.nativeElement.scrollIntoView({ block: 'nearest' });
    }
}
